import React from 'react';

import { Popover } from 'antd';

import styled from 'styled-components';

import useNwBreakPoints from '@hooks/Layout/UseNwBreakPoints';

import CreatedBy from '@components/CreatedBy/CreatedBy';
import LastEditedBy from '@components/CreatedBy/LastEditedBy';
// import PropTypes from 'prop-types';
import NwIcon from '@components/Gui/NwIcon';

import { byPrefixAndName } from '@awesome.me/kit-d6dae216cd/icons';

const Container = styled.div`
    display: flex;
    align-items: center;
    text-align: right;

    .icon {
        margin: 0 0.5rem;
    }

    .separator {
        padding: 0 1em;
    }

    ${(props) =>
        props.$muted &&
        `
        color: ${props.theme.TextColorMuted};
        font-size: ${props.theme.FontSizeSm};
        text-transform: uppercase;

        .icon {
            margin: 0 0.35rem 0 0;
            color: ${props.theme.TextColorMuted};
            opacity: 0.65;
            font-size: 0.85rem;
        }

        .history-details,
        .created-by,
        .last-edited-by {
            color: ${props.theme.TextColorMuted};
        }
    `}
`;

const ObjectHistory = ({ object, onIconClick, asLine, iconOnly, muted }) => {
    const breakpoints = useNwBreakPoints();
    return iconOnly ? (
        <Popover
            title="History"
            content={
                <div style={{ fontSize: '.8rem' }}>
                    <CreatedBy breaklines object={object} noWrap extra="Created" />
                    {object.DateModified && <LastEditedBy breaklines object={object} noWrap extra="Last Edited By" />}
                </div>
            }
            placement="right"
            trigger="hover"
        >
            <NwIcon
                style={{ fontSize: 20 }}
                onClick={onIconClick}
                className="icon"
                icon={byPrefixAndName.fasl['history']}
            />
        </Popover>
    ) : breakpoints !== 1 && asLine ? (
        <Container $muted={muted} className="history-details" onClick={onIconClick}>
            <NwIcon onClick={onIconClick} className="icon" icon={byPrefixAndName.fasl['history']} />
            <CreatedBy object={object} noWrap extra="Created" />
            {object.DateModified && (
                <>
                    <span className="separator">&bull;</span>
                    <LastEditedBy object={object} noWrap extra="Last Edited By" />
                </>
            )}
        </Container>
    ) : (
        <Container $muted={muted} onClick={onIconClick}>
            <NwIcon
                className="icon"
                icon={byPrefixAndName.fasl['history']}
                size={muted ? undefined : '2x'}
            />
            <div className="history-details">
                <CreatedBy object={object} noWrap extra="" />
                {object.DateModified && <LastEditedBy object={object} noWrap extra="edited by" />}
            </div>
        </Container>
    );
};

// ObjectHistory.propTypes = {
//   object: PropTypes.shape({
//     ID: PropTypes.number.isRequired
//   }).isRequired,
//   onIconClick: PropTypes.func,
// }

// ObjectHistory.defaultProps = {
//   onIconClick: () => null
// }

export default ObjectHistory;
